import React from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { saveSingle } from "../../services/projectService";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import { Table } from "semantic-ui-react";
import TableTitle from "../common/tableTitle";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

class ProjectForm extends Form {
  state = {
    ref_date: new Date(),
    data: {
      company_name: "",
      project_name: "",
      mobile_tel: "",
      mobile_tel1: "",
      email: "",
      project_code: "",
      work_order: "",
      trn: "",
      consultant_name: "",
      consultant_email: "",
      consultant_phone1: "",
      consultant_phone2: "",
    },
    errors: {},
  };

  schema = {
    id: Joi.string(),
    company_name: Joi.string().required().label("Company Name"),
    project_name: Joi.string().required().label("Project Name"),
    mobile_tel: Joi.string().required().label("Mobile/Tel1"),
    mobile_tel1: Joi.allow("").label("Mobile/Tel2"),
    email: Joi.string().required().label("Email"),
    project_code: Joi.string().required().label("Project Code"),
    work_order: Joi.string().required().label("Work Order"),
    trn: Joi.string().required().label("TRN"),
    consultant_name: Joi.allow("").label("Name"),
    consultant_email: Joi.allow("").label("Email"),
    consultant_phone1: Joi.allow("").label("Mobile/Tel1"),
    consultant_phone2: Joi.allow("").label("Mobile/Tel2"),
  };

  handleChangeExpiry = (date) => {
    this.setState({
      ref_date: date,
    });
  };

  doSubmit = async () => {
    try {
      this.setState({ blocking: true });

      let formData = new FormData();
      formData.append("company_name", this.state.data.company_name);
      formData.append("project_name", this.state.data.project_name);
      formData.append("mobile_tel", this.state.data.mobile_tel);
      formData.append("mobile_tel1", this.state.data.mobile_tel1);

      formData.append("email", this.state.data.email);
      formData.append("project_code", this.state.data.project_code);
      formData.append("work_order", this.state.data.work_order);

      formData.append("consultant_name", this.state.data.consultant_name);
      formData.append("consultant_email", this.state.data.consultant_email);
      formData.append("consultant_phone1", this.state.data.consultant_phone1);
      formData.append("consultant_phone2", this.state.data.consultant_phone2);

      var event = new Date(this.state.ref_date);
      let date = JSON.stringify(event);
      date = date.slice(1, 11);
      formData.append("ref_date", date);

      formData.append("trn", this.state.data.trn);

      await saveSingle(formData);

      toast.success("Account has been added successfully.");
      this.setState({ blocking: false });
      this.props.history.push("/projects-accounts");
    } catch (ex) {
      console.log(ex.response);
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.company_name)
          errors.company_name = ex.response.data.errors.company_name;

        if (ex.response.data.errors.project_name)
          errors.project_name = ex.response.data.errors.project_name;

        if (ex.response.data.errors.mobile_tel)
          errors.mobile_tel = ex.response.data.errors.mobile_tel;

        if (ex.response.data.errors.email)
          errors.email = ex.response.data.errors.email;

        if (ex.response.data.errors.project_code)
          errors.project_code = ex.response.data.errors.project_code;

        if (ex.response.data.errors.work_order)
          errors.work_order = ex.response.data.errors.work_order;

        this.setState({ errors, blocking: false });
        //toast.warning("check validation errors.");
      }
    }
  };

  render() {
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <h1 className="container__heading">Add project</h1>
        <button
          className="btn btn--secondary"
          onClick={() => this.props.history.push("/projects-accounts")}
        >
          Back
        </button>
        <form onSubmit={this.handleSubmit}>
          <div className="card form">
            <div className="form__content">
              <h3 className="card__heading">Add project</h3>
              <p>Provide the information below to add the project.</p>
              <p>
                <b>OWNER INFORMATION</b>
              </p>
              <div class="c_container">
                <div class="c_column">
                  <div class="c_field">
                    {this.renderInput(
                      "company_name",
                      "Client / Company Name",
                      "text"
                    )}
                  </div>
                  <div class="c_field">
                    {this.renderInput("mobile_tel", "Mobile/Tel1", "text")}
                  </div>
                </div>
                <div class="c_column">
                  <div class="c_field">
                    {this.renderInput("email", "Email", "text")}
                  </div>
                  <div class="c_field">
                    {this.renderInput("mobile_tel1", "Mobile/Tel2", "text")}
                  </div>
                </div>
              </div>

              <p>
                <b>CONSULTANT INFORMATION</b>
              </p>
              <div class="c_container">
                <div class="c_column">
                  <div class="c_field">
                    {this.renderInput("consultant_name", "Name", "text")}
                  </div>
                  <div class="c_field">
                    {this.renderInput(
                      "consultant_phone1",
                      "Mobile/Tel1",
                      "text"
                    )}
                  </div>
                </div>
                <div class="c_column">
                  <div class="c_field">
                    {this.renderInput("consultant_email", "Email", "text")}
                  </div>
                  <div class="c_field">
                    {this.renderInput(
                      "consultant_phone2",
                      "Mobile/Tel2",
                      "text"
                    )}
                  </div>
                </div>
              </div>

              <p>
                <b>PROJECT INFORMATION</b>
              </p>
              <div class="c_container">
                <div class="c_column">
                  <div class="c_field">
                    {this.renderInput("project_name", "Project Name", "text")}
                  </div>
                  <div class="c_field">
                    {this.renderInput("project_code", "Project Code", "text")}
                  </div>
                  <div class="c_field">
                    {this.renderInput("trn", "TRN", "text")}
                  </div>
                </div>
                <div class="c_column">
                  <div class="c_field">
                    {this.renderInput("work_order", "Work Order", "text")}
                  </div>
                  <div class="c_field">
                    <label>Ref Date</label>
                    <DatePicker
                      selected={this.state.ref_date}
                      onChange={this.handleChangeExpiry}
                      className="input"
                    />
                  </div>
                </div>
              </div>

              {this.renderButton("Save")}
            </div>
          </div>
        </form>
      </BlockUi>
    );
  }
}

export default ProjectForm;
